var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-info",
    clipPath: "url(#clip0_4881_36979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M6.25977 12.0103C7.85106 12.0103 9.37719 11.3781 10.5024 10.2529C11.6276 9.12768 12.2598 7.60155 12.2598 6.01025C12.2598 4.41895 11.6276 2.89283 10.5024 1.76761C9.37719 0.642395 7.85106 0.0102539 6.25977 0.0102539C4.66847 0.0102539 3.14234 0.642395 2.01713 1.76761C0.891907 2.89283 0.259766 4.41895 0.259766 6.01025C0.259766 7.60155 0.891907 9.12768 2.01713 10.2529C3.14234 11.3781 4.66847 12.0103 6.25977 12.0103ZM5.32227 7.88525H5.88477V6.38525H5.32227C5.01055 6.38525 4.75977 6.13447 4.75977 5.82275C4.75977 5.51103 5.01055 5.26025 5.32227 5.26025H6.44727C6.75898 5.26025 7.00977 5.51103 7.00977 5.82275V7.88525H7.19727C7.50898 7.88525 7.75977 8.13603 7.75977 8.44775C7.75977 8.75947 7.50898 9.01025 7.19727 9.01025H5.32227C5.01055 9.01025 4.75977 8.75947 4.75977 8.44775C4.75977 8.13603 5.01055 7.88525 5.32227 7.88525ZM6.25977 3.01025C6.45868 3.01025 6.64944 3.08927 6.7901 3.22992C6.93075 3.37058 7.00977 3.56134 7.00977 3.76025C7.00977 3.95917 6.93075 4.14993 6.7901 4.29058C6.64944 4.43124 6.45868 4.51025 6.25977 4.51025C6.06085 4.51025 5.87009 4.43124 5.72944 4.29058C5.58878 4.14993 5.50977 3.95917 5.50977 3.76025C5.50977 3.56134 5.58878 3.37058 5.72944 3.22992C5.87009 3.08927 6.06085 3.01025 6.25977 3.01025Z",
    fill: "#8485C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4881_36979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfo);
export default __webpack_public_path__ + "static/media/circle-info.dd8985c6357fad3d670a52a2cb174232.svg";
export { ForwardRef as ReactComponent };